import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toLower } from "lodash";
import React, { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { FormControl } from "../../";

const FieldInputTrash = ({ field, form, ...rest }) => {
  const {
    preventSpecialCharacter = false,
    onlyNumbersAndHyphen = false,
    forMapper = false,
    disabled,
    isAdded,
    onDeleteClick,
  } = rest;
  const [focusClass, setFocusClass] = useState("");
  let format = /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;
  let numPadNumberKeyCodes = [
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    96,
    97,
    98,
    99,
    100,
    101,
    102,
    103,
    104,
    105,
  ];
  let autoCompleteAttr = {
    autoComplete: "off",
  };
  if (["name", "firstName", "lastName", "middleName"].includes(field.name)) {
    autoCompleteAttr = {
      autoComplete: "new-name",
    };
  }
  if (rest.type === "password") {
    autoCompleteAttr = {
      autoComplete: "new-password",
    };
  }
  if (field.name === "email") {
    autoCompleteAttr = {
      autoComplete: "new-email",
    };
  }

  if (
    toLower(field.name).indexOf("postal") !== -1 ||
    toLower(field.name).indexOf("zip") !== -1
  ) {
    autoCompleteAttr = {
      autoComplete: "new-zip",
    };
  }

  const onDollarInputFocus = () => {
    setFocusClass("focus");
  };

  const onDollarInputBlur = (e) => {
    // const { handleBlur } = rest;
    setFocusClass("");
    // handleBlur(e);
  };

  return (
    <FormControl {...field} {...form} {...rest}>
      {!isAdded ? (
        <Form.Control
          onKeyDown={(event) => {
            if (
              (preventSpecialCharacter && event.key.match(format)) ||
              (onlyNumbersAndHyphen &&
                numPadNumberKeyCodes.includes(event.keyCode))
            ) {
              event.preventDefault();
            }
          }}
          {...field}
          {...rest}
          {...autoCompleteAttr}
          className={forMapper ? "container-size" : ""}
        />
      ) : (
        <InputGroup
          className={`input-dollar-wrapper ${focusClass}`}
          style={{ maxWidth: "15rem", flexWrap: "nowrap" }}
        >
          <Form.Control
            onKeyDown={(event) => {
              if (
                (preventSpecialCharacter && event.key.match(format)) ||
                (onlyNumbersAndHyphen &&
                  numPadNumberKeyCodes.includes(event.keyCode))
              ) {
                event.preventDefault();
              }
            }}
            {...field}
            {...rest}
            {...autoCompleteAttr}
            onFocus={onDollarInputFocus}
            onBlur={onDollarInputBlur}
            className={forMapper ? "container-size-new" : ""}
          />
          <InputGroup.Append>
            <InputGroup.Text
              className={`input-dollar ${disabled ? "disabled" : ""} ${
                forMapper ? "trash-container-size" : ""
              }`}
            >
              {isAdded && (
                <FontAwesomeIcon
                  color="#F16973"
                  className="ft-16 mr-1 cursor-pointer"
                  icon={faTrashAlt}
                  onClick={() => onDeleteClick()}
                />
              )}
            </InputGroup.Text>
          </InputGroup.Append>
        </InputGroup>
      )}
    </FormControl>
  );
};

export default FieldInputTrash;
